import { IconPhoto, IconUpload } from "@tabler/icons-react"
import type { FC } from "react"

import { cn } from "@forento/ui/utilities/tailwind"

type Props = {
	label: string
	description: string
	files: File[]
	onChange(files: File[]): void
	multiple?: boolean
	maxFiles?: number
}
const AiImagePicker: FC<Props> = ({ label, description, files, onChange, multiple, maxFiles }) => (
	<div>
		<div className="mb-1.5 text-sm font-semibold text-[#444444]">{label}</div>
		<label className="hover:border-primary hover:bg-primary/5 flex cursor-pointer flex-col gap-3 rounded-xl border border-dashed border-gray-300 bg-gray-50 p-4 transition-colors">
			<div className="flex items-start gap-3">
				<div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-white text-gray-500 shadow-sm">
					<IconPhoto className="size-5" />
				</div>
				<div className="min-w-0 flex-1 self-center text-xs text-gray-500">{description}</div>
				<IconUpload className="size-5 text-gray-400" />
			</div>
			<input
				type="file"
				accept="image/*"
				multiple={multiple}
				className="sr-only"
				onChange={event => {
					const selected = Array.from(event.target.files ?? []).slice(0, maxFiles)
					// A file input keeps its value, so picking the same file again fires no change event.
					// Clearing it after reading the selection is what lets a file be re-picked.
					event.target.value = ""
					onChange(selected)
				}}
			/>
			<div className="flex items-baseline justify-between gap-3 text-xs">
				<div className={cn("min-w-0 text-gray-500", files.length > 0 && "text-gray-700")}>
					{files.length > 0 ? files.map(file => file.name).join(", ") : "Choose image"}
				</div>
				{maxFiles !== undefined && (
					<div className="shrink-0 font-medium text-gray-500">
						{files.length}/{maxFiles} images
					</div>
				)}
			</div>
		</label>
	</div>
)

export default AiImagePicker
